var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('app-header'), _c('div', {
    staticClass: "app-body"
  }, [_c('app-sidebar', {
    attrs: {
      "navItems": _vm.nav
    }
  }), _c('main', {
    staticClass: "main"
  }, [_c('app-breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }), _c('div', {
    staticClass: "container-fluid"
  }, [(_vm.list.length > 1) ? _c('router-view') : _c('Home')], 1)], 1), _c('app-aside')], 1), _c('app-footer')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b966b02","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Full.vue
// module id = 863
// module chunks = 1